import React from "react";
import ErrorPage from "components/errors/ErrorPage";
import useProductName from "brand-customization/useProductName";
const PageErrorOverview = ({ errors }) => {
  const productName = useProductName();
  const formattedErrors = errors ? errors.map((error) => /* @__PURE__ */ React.createElement("li", { key: `key-${error.toString()}` }, error.toString())) : [];
  const description = /* @__PURE__ */ React.createElement("p", null, "We had trouble fetching some data required to build this page, so here is a picture instead.");
  return /* @__PURE__ */ React.createElement(ErrorPage, { title: "Error getting data", description, displayPageLayout: false }, /* @__PURE__ */ React.createElement("ul", null, formattedErrors, /* @__PURE__ */ React.createElement("li", null, "Check your ", productName, " server logs for more information.")));
};
export default PageErrorOverview;
